import React from "react";
import {Button, Col, Typography} from "antd";
import {PlusOutlined} from "@ant-design/icons";
import CardCom from "../CardCom";

const {Text, Title} = Typography

export class FicheCom extends React.Component {


    render() {
        const {selected, fiche} = this.props

        if (!selected) {
            return null
        }

        if (selected.commentaires.length === 0) {
            return null
        }

        return (
            <Col>
                <Col style={{display: "flex", justifyContent: "flex-end", marginBottom: 20}}>
                    <Button type="primary" icon={<PlusOutlined/>} onClick={() => fiche.modalAddCom.show(selected.id)}>Ajouter
                        une activité</Button>
                </Col>
                {
                    [...selected.commentaires].reverse().map((item, index) => {
                        return (
                            <CardCom contact={selected.id} item={item} editable onChange={() => fiche.getData()}/>
                        )
                    })
                }
            </Col>
        )
    }
}
